/* eslint-disable */
import React from 'react'
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import { TextBodyOne } from '../text'
import icJoin from '../../static/icons/ic-ava-register.svg'
import Icon from '../icons'
import { Style } from './index.styles'

const CardJoin = ({
  desc,
  backgroundImage,
  buttonColor,
  boxShadow,
  border,
  image,
  ava,
  marginTop
}) => {
  const { t } = useTranslation();

  return (
    <Style
      marginTop={marginTop}
      boxShadow={boxShadow}
      border={border}
      buttonColor={buttonColor}
    >
      <img src={backgroundImage} alt="haojasa/background" />
      <Grid>
        <Row bottom="lg">
          <Col sm={12} xs={12} md={12} lg={6}>
            <div className="card">
              <div className="title">{t('pageServiceAcJakarta.part50')}</div>
              <TextBodyOne display="block" align="left">
                {desc}
              </TextBodyOne>
              <div className="join">
                <Link target="_blank" to="/register/vendor" className="glass-hover">
                  {t('pageServiceAcJakarta.part52')} <Icon size={12} name="chevronRight"></Icon>
                </Link>
                <img src={ava || icJoin} alt="halojasa/avatar" />
              </div>
            </div>
          </Col>
          <Col sm={12} xs={12} md={12} lg={6}>
            <img className="ilus" src={image} alt="halojasa/ilustrator" />
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default CardJoin
